<template>
  <div class="contact-tile-fi">
    <div class="contact-tile-fi__contact-details-head">
      <div class="contact-tile-fi__image-container">
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="isEditMode"
          class="contact-tile-fi__image-editor"
          v-html="fields.image.editable"
        />
        <!-- eslint-enabled vue/no-v-html -->
        <cloud-image-fi
          v-else-if="fields.image?.value?.src"
          class="contact-tile-fi__image"
          :src="fields.image?.value?.src"
          :alt="fields.image?.value?.alt"
        />
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="isEditMode"
        class="contact-tile-fi__name"
        v-html="fields.name.editable"
      />
      <div
        v-if="!isEditMode && fields.name?.value"
        class="contact-tile-fi__name"
        v-html="fields.name.value"
      />
      <div
        v-if="isEditMode"
        class="contact-tile-fi__role"
        v-html="fields.role.editable"
      />
      <div
        v-if="!isEditMode && fields.role?.value"
        class="contact-tile-fi__role"
        v-html="fields.role.value"
      />
      <!-- eslint-enable vue/no-v-html -->
    </div>
    <contact-details-fi
      class="contact-tile-fi__contact-details"
      :phonenumber1="fields.phonenumber1"
      :phonenumber2="fields.phonenumber2"
      :fax="fields.fax"
      :email="fields.email"
    />
  </div>
</template>

<script>
import CloudImageFi from 'components/atoms/cloud-image-fi/CloudImageFi';
import ContactDetailsFi from 'components/contact-details-fi/ContactDetailsFi';

export default {
  name: 'ContactTileFi',
  components: {
    CloudImageFi,
    ContactDetailsFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
@import './contact-tile-fi-unscoped.scss';
</style>

<style lang="scss" scoped>
@import './contact-tile-fi.scss';
</style>
